import { Button } from 'antd';
import { Download, Plus, Upload } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router';
import { LineDialogs, type LineDialog } from './LineDialogs';
import { LineFilters } from './LineFilters';
import { LinesResults } from './LinesResults';
import { rateLineExportUrl, type RateCardView } from '../../../rate-cards.api';
import { useRateCardPermissions } from '../../../hooks/use-rate-card-permissions';
import { rateCardImportPath } from '../../../rate-cards.paths';
import { useRateLines } from '../hooks/use-rate-lines';

/** Published lines only — a draft is not a price yet and lives on the Proposals tab. */
export function LinesTab({ card }: { card: RateCardView }) {
  const { list, query, state, isRefreshing } = useRateLines(card.id);
  const { canEdit } = useRateCardPermissions();
  const [dialog, setDialog] = useState<LineDialog | null>(null);
  const isCurrent = query.current ?? true;
  const canEditCard = canEdit && card.isActive;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <LineFilters list={list} isCurrent={isCurrent} />
        <div className="flex flex-wrap gap-2">
          <a href={rateLineExportUrl(card.id, false)}>
            <Button icon={<Download className="size-4" />}>Export</Button>
          </a>
          {canEditCard && (
            <Link to={rateCardImportPath(card.id)}>
              <Button icon={<Upload className="size-4" />}>Import</Button>
            </Link>
          )}
          {canEditCard && (
            <Button type="primary" icon={<Plus className="size-4" />} onClick={() => setDialog({ kind: 'add' })}>
              Add line
            </Button>
          )}
        </div>
      </div>
      <LinesResults
        state={state}
        isRefreshing={isRefreshing}
        list={list}
        isCurrent={isCurrent}
        canEdit={canEditCard}
        onChangePrice={(line) => setDialog({ kind: 'change', line })}
        onShowHistory={(line) => setDialog({ kind: 'history', line })}
      />
      <LineDialogs dialog={dialog} rateCardId={card.id} onClose={() => setDialog(null)} />
    </div>
  );
}
